import { Voucher } from 'components/analytics/voucher/Voucher'
import { useLocation, useSearchParams } from 'react-router-dom'
import { downloadFile, getAllQueryParams, setQueryParams } from 'utils/utils'
import { INITIAL_DATA_FILTER } from 'configs/analytics/configTableVoucher'
import { useEffect, useState } from 'react'
import { useFetch } from 'services/useFetch'
import { API_VOUCHER } from 'services/apiAnalyticVoucher'
import { Alert } from 'avo-ui'

export const VoucherContainer = () => {
    const location = useLocation()
    const [searchParams, setSearchParams] = useSearchParams()
    const query = searchParams.size > 0 ? getAllQueryParams(searchParams) : INITIAL_DATA_FILTER
    const [showModalExport, setShowModalExport] = useState(false)
    const { fetching: getVoucherGraph, data: voucherGraph, isLoading: isLoadingGraph } = useFetch(API_VOUCHER.GRAPH)
    const { fetching: getVoucherList, data: voucherList, isLoading: isLoadingList } = useFetch(API_VOUCHER.LIST)
    const { fetching: exportVoucherList, isLoading: isLoadingExport } = useFetch(API_VOUCHER.EXPORT)
    const {
        fetching: getVoucherComparison,
        data: voucherComparison,
        isLoading: isLoadingComparison,
    } = useFetch(API_VOUCHER.COMPARISON)

    useEffect(() => {
        const { search, page, limit, orderBy, orderType, ...queryRest } = query
        getVoucherGraph(queryRest)
        getVoucherComparison(queryRest)
    }, [query?.startDate, query?.endDate])

    useEffect(() => {
        getVoucherList({ ...query })
    }, [location?.search])

    const onChangeQuery = (queryParams) => {
        const params = setQueryParams({ ...query, ...queryParams })
        setSearchParams(params, { replace: true })
    }

    const setShowModalExportHandler = (value) => {
        setShowModalExport(value)
    }

    const onSelectSort = (value) => {
        const splitSort = value?.split('_')
        onChangeQuery({ orderBy: splitSort[0], orderType: splitSort[1] })
    }

    const onExport = () => {
        const { page, limit, ...queryRest } = query
        exportVoucherList(queryRest, '', {}, 'blob').then((response) => {
            downloadFile(null, response, `Analytic-Voucher-Export-Start_${query?.startDate}-End_${query?.endDate}.xlsx`)
            setShowModalExport(false)
            return Alert({
                icon: 'success',
                title: 'Success',
                message: 'Analytic Voucher Exported',
            })
        })
    }

    const props = {
        dataComparison: voucherComparison?.data,
        dataGraph: voucherGraph?.data,
        dataList: voucherList?.data,
        query,
        onChangeQuery,
        onSelectSort,
        showModalExport,
        setShowModalExportHandler,
        isLoadingComparison,
        isLoadingGraph,
        isLoadingList,
        isLoadingExport,
        onExport,
    }

    return <Voucher {...props} />
}
